import { createNewText, addTaskButtonText } from './QuickAdd.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47647 */
import * as React from 'react';
import getQuickAddViewState from '../selectors/getQuickAddViewState';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { addTodo, setIsFocused, setSubject } from '../actions/quickAddActions';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ITextField, TextField } from 'office-ui-fabric-react/lib/TextField';
import { KeyboardEvent } from 'react';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import { observer } from 'mobx-react';

const styles = require('./QuickAdd.scss');
const classNames = require('classnames/bind').bind(styles);
const MAX_SUBJECT_LENGTH = 255;

@observer
export default class QuickAdd extends React.Component<{}, {}> {
    private textInput: ITextField;
    private forwardTextInputRef = ref => (this.textInput = ref);

    render() {
        const uiState = getQuickAddViewState();

        if (!uiState.isShown) {
            return null;
        }

        const rightButtonShown: boolean = uiState.isFocused || uiState.subject.trim().length > 0;
        const rightButtonDisabled: boolean = uiState.subject.trim().length == 0;

        return (
            <div
                className={classNames(styles.addTask, {
                    highlightNoText: uiState.isFocused && rightButtonDisabled,
                    highlight: !rightButtonDisabled,
                })}>
                <div
                    onClick={() => {
                        this.onPlusButtonClick();
                    }}
                    title={loc(createNewText)}
                    className={styles.leftIconPlusContainer}>
                    <Icon
                        iconName={ControlIcons.Add}
                        className={classNames(styles.leftIconPlus, {
                            disabled: rightButtonShown && rightButtonDisabled,
                        })}
                    />
                </div>

                <TextField
                    componentRef={this.forwardTextInputRef}
                    className={styles.addTaskWrapper}
                    styles={{ field: styles.addTaskInput }}
                    onChange={this.updateSubject}
                    borderless={true}
                    value={uiState.subject}
                    maxLength={MAX_SUBJECT_LENGTH}
                    autoFocus={false}
                    onFocus={target => this.subjectOnFocus()}
                    onBlur={target => this.subjectOnBlur()}
                    onKeyDown={target => this.subjectOnKeyDown(target)}
                    placeholder={loc(createNewText)}
                    ariaLabel={loc(createNewText)}
                />
                {rightButtonShown && (
                    <ActionButton
                        className={styles.rightButton}
                        disabled={rightButtonDisabled}
                        text={loc(addTaskButtonText)}
                        styles={{
                            rootDisabled: styles.rightButtonDisabled,
                            label: styles.rightButtonLabel,
                            flexContainer: styles.buttonFlexContainer,
                        }}
                        onClick={() => {
                            this.addTask();
                        }}
                    />
                )}
            </div>
        );
    }

    private onPlusButtonClick = () => {
        if (this.textInput) {
            this.textInput.focus();
            this.addTask();
        }
    };

    private updateSubject(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue: string
    ) {
        setSubject(newValue);
    }

    private subjectOnFocus() {
        setIsFocused(true);
    }

    private subjectOnBlur = () => {
        setIsFocused(false);

        // If user has typed empty spaces, placeholder won't be shown.
        // This makes the UI look really awkward. So clearn out any empty spaces.
        const uiState = getQuickAddViewState();
        if (uiState.subject.length > 0 && uiState.subject.trim().length === 0) {
            this.updateSubject(null, '');
        }
    };

    private subjectOnKeyDown = (target: KeyboardEvent<EventTarget>) => {
        switch (target.keyCode) {
            case KeyCodes.enter:
                target.preventDefault();
                target.stopPropagation();
                this.addTask();

                break;
            case KeyCodes.escape:
                let uiState = getQuickAddViewState();
                if (uiState.subject.trim().length > 0) {
                    target.preventDefault();
                    target.stopPropagation();
                }
                break;
        }
    };

    private addTask = () => {
        const uiState = getQuickAddViewState();

        if (uiState && uiState.subject && uiState.subject.trim().length > 0) {
            addTodo(
                uiState.subject,
                uiState.folderId,
                uiState.linkedEmailEntity,
                uiState.extractionId
            );
        }

        // Move focus back into the text field no matter how the task was added
        // e.g. clicking on right button
        if (this.textInput) {
            this.textInput.focus();
        }
    };
}
